import ActionsGenerator from '../../lib/ActionsGenerator'

const generator = new ActionsGenerator('plan_product', '/plan_products')
const actions = generator.generate()

export default actions
